<section>
  <app-tips
    *appIsEnabled="toggleNameEnum.TipsSearchAdvice"
    class="block mt-4"
    [title]="'attendee.result_page.advice_tips.title' | translate"
    [tips]="tips"
    [icon]="iconTypeEnum.Information"
  ></app-tips>

  <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>

  <app-attendee-pagination
    *ngIf="!isLoading"
    class="block mt-4"
    [items]="advices"
    [itemsType]="paginationType.ADVICES"
    [hasLoadMoreButton]="hasLoadMoreButton"
    (loadMoreAction)="loadMore()"
    (filterReset)="resetFilters()"
  ></app-attendee-pagination>
</section>
